export enum ItemType {
  ITEM = 'ITEM',
  SPECIAL = 'SPECIAL',
  FUNDRAISER = 'FUNDRAISER',
  UNKNOWN = 'UNKNOWN',
}
